import { jsPDF } from 'jspdf';
import { LayoutEngine } from './layout/LayoutEngine';
import { loadLogoBase64 } from './utils/imageLoader';
import { drawHeader } from './components/Header';
import { drawInfoBoxes } from './components/InfoBoxes';
import { drawProductTable, groupCartItemsBySku } from './components/ProductTable';
import { drawSummary } from './components/Summary';
import { drawSignature } from './components/Signature';
import { drawTerms } from './components/Terms';
import { drawContactFooter } from './components/Footer';
import { DEFAULT_SPACING } from './constants/theme';

export const generateOrderPDF = async (draft = {}, orderNumber = "", orderDateStr = "") => {
    const { selectedCustomer, cartItems = [], shippingDetails = {}, signature } = draft;

    const logoImgData = await loadLogoBase64();

    const doc = new jsPDF({
        orientation: 'portrait',
        unit: 'pt',
        format: 'letter'
    });

    const engine = new LayoutEngine(doc);

    // 1. Header Section
    engine.section({}, () => {
        drawHeader(engine, { logoImgData, orderNumber });
    });

    // 2. Customer & Address Information Boxes Section
    let infoBoxesEndY;
    engine.section({ marginTop: DEFAULT_SPACING.headerBottom }, () => {
        infoBoxesEndY = drawInfoBoxes(engine, { selectedCustomer, shippingDetails, orderDateStr });
    });

    // 3. Product Blocks Section
    if (infoBoxesEndY) {
        engine.getCursor().setY(infoBoxesEndY + 12);
    }
    await drawProductTable(engine, cartItems);

    // 4. Grand Totals Summary Section
    const groups = groupCartItemsBySku(cartItems);
    drawSummary(engine, { cartItems, groupsCount: groups.length });

    // 5. Customer Signature Section
    await drawSignature(engine, signature, orderDateStr);

    // 6. Terms and Conditions Pages
    drawTerms(engine);

    // 7. Contact Us & Page Footer
    drawContactFooter(engine);

    // 8. Apply Sticky Dark Page Numbers
    engine.getPageManager().applyStickyPageNumbers();

    return doc;
};
